<template>
  <div class="container" :class="{empty:!id}">
    <img :src="addTeacher" class="add-teacher" v-if="id" />
    <div class="content" v-if="id">
      <div class="info">
        <van-image :src="success" class="success" />
        <div class="tip">恭喜你成功抢购课程</div>
      </div>
      <div class="info-sum">
        <div class="activation">
          现在添加你的专属班主任，激活课程服务
        </div>
        <div class="add" @click="goWeixin">立即添加</div>
        <img :src="answering" class="answering" />
      </div>
    </div>
    <div v-else>学小成</div>
  </div>
</template>

<script>
export default {
  name: 'PickActivity',
  components: {},
  props: {},
  data() {
    return {
      addTeacher: require('@/assets/add_teacher.png'),
      success: require('@/assets/success.png'),
      answering: require('@/assets/answering.png'),
      timer: null,
      url: '',
      id: '',
      userId: ''
    }
  },
  created() {
    // this.userId = this.$route.query.userId
    if (this.$route.params && this.$route.params.id) {
      this.id = this.$route.params.id
      this.getMaSchemeByCode()
    }
  },
  mounted() {},
  destroyed() {
    clearTimeout(this.timer)
    this.timer = null
  },
  methods: {
    async getMaSchemeByCode() {
      if (!this.id) return
      const res = await this.$http.get('/app/channels/getMaSchemeByCode', {
        code: this.id
      })

      this.url = res.data || ''
      if (this.url) {
        this.timer = setTimeout(() => {
          this.goWeixin()
        }, 2000)
      }
    },
    goWeixin() {
      // window.location.href = 'weixin://dl/business/?appid=wx2fa3691b1bc69740&path=pages/index/index&env_version=release'
      if (this.url) {
        window.location.href = this.url
      }
    }
  }
}
</script>

<style scoped lang="less">
.empty {
  background: #fff;
}
.container {
  font-size: 28px;
  color: #333;
  background: #1fcc78;
  height: 100vh;
  .content {
    padding: 32px;
    margin-top: -90px;
    position: relative;
  }
  .add-teacher {
    width: 100%;
    height: 370px;
  }
  .info {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: #fff7ed;
    border-radius: 40px 40px 0 0;
    height: 214px;
    .tip {
      font-size: 30px;
    }
    .success {
      width: 80px;
      height: 80px;
      margin-bottom: 16px;
    }
  }

  .info-sum {
    background: #fff;
    border-radius: 0 0 40px 40px;
    height: 654px;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;
    .answering {
      width: 620px;
      height: 220px;
    }
    .activation {
      font-size: 32px;
      font-weight: 700;
      padding: 96px 0 40px;
      text-align: center;
    }
    .add {
      width: 622px;
      height: 100px;
      background: #fb0;
      border-radius: 50px;
      display: block;
      line-height: 100px;
      text-align: center;
      font-size: 40px;
      color: #fff;
      font-weight: 700;
      outline: none;
      margin-bottom: 107px;
      -webkit-animation: fadenum 0.8s ease infinite;
      animation: fadenum 0.8s ease infinite;
    }
  }
}
@keyframes fadenum {
  0% {
    transform: scale(0.95);
    -webkit-transform: scale(0.95);
  }
  50% {
    transform: scale(1.02);
    -webkit-transform: scale(1.02);
  }
  100% {
    transform: scale(0.95);
    -webkit-transform: scale(0.95);
  }
}
</style>
